import { Button, ButtonVariation } from '../../../../components/Button';
import './DeleteLaborCategoryModal.css';

export interface DeleteLaborCategoryModalProps {
  categoryName: string;
  onCancel: () => void;
  onConfirm: () => void;
  'data-testid'?: string;
}

function DeleteLaborCategoryModal({
  categoryName,
  onCancel,
  onConfirm,
  'data-testid': dataTestId,
}: DeleteLaborCategoryModalProps) {
  const baseTestId = dataTestId ?? 'delete-labor-category-modal';

  return (
    <div
      className='delete-labor-category-modal'
      data-testid={baseTestId}>
      <p
        className='delete-labor-category-modal__text'
        data-testid={`${baseTestId}-text`}>
        Are you sure you want to delete <strong data-testid={`${baseTestId}-category-name`}>{categoryName}</strong>?
      </p>
      <div
        className='delete-labor-category-modal__actions'
        data-testid={`${baseTestId}-actions`}>
        <Button
          isAutoWidth
          data-testid={`${baseTestId}-cancel`}
          type='button'
          variation={ButtonVariation.GHOST}
          onClick={onCancel}>
          Cancel
        </Button>
        <Button
          isAutoWidth
          data-testid={`${baseTestId}-confirm`}
          type='button'
          variation={ButtonVariation.SOLID}
          onClick={onConfirm}>
          Delete
        </Button>
      </div>
    </div>
  );
}

export default DeleteLaborCategoryModal;
